export default "__VITE_ASSET__D9mmYI8Q__"